import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ItineraryType } from 'src/app/assabil-kernel/models/entities/control-tables/itinerary-type';
import { ItineraryTypeRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/itinerary-type-request';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';


@Component({
  selector: 'app-itinerary-type-list',
  templateUrl: './itinerary-type-list.component.html',
  styleUrls: ['./itinerary-type-list.component.scss']
})
export class ItineraryTypeListComponent extends BasePage2<ItineraryType > {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  itineraryTypes: ItineraryType[] = [];
  // ---------------------------------------------------
  

  constructor(
      protected toastr            : ToastrService,
      protected controlService    : ControlTablesService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = "itineraryType";
      
  }


  listFields = [
      { prop: 'itineraryTypeCode', name: 'Code',  insertOnly : true},
      { prop: 'name', name: 'Name' },
      { prop: 'rank', name: 'Rang' },
  ]

  getRows(): ItineraryType[] {
      return this.itineraryTypes;
  }


  //----------------------------------------------------------------------
  new(){
    let entity : ItineraryType = new ItineraryType();
    entity.inserted = true;
    entity.edit = true;
    this.itineraryTypes.push(entity);
    this.itineraryTypes = [...this.itineraryTypes];
    }
//----------------------------------------------------------------------



//----------------------------------------------------------------------
  saveRow(itineraryType: ItineraryType): Promise<ItineraryType> {
    let request  : ItineraryTypeRequest = new ItineraryTypeRequest(this.controlService.getUserInfo());
    request.itineraryType = itineraryType;
      return this.controlService.save(this.entityName, request);
  }
//----------------------------------------------------------------------



//----------------------------------------------------------------------
  loadData() {
    let request         : BaseRequest = this.controlService.getRequest();
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlService.getList(this.entityName, request).then(result => {
        this.itineraryTypes = result;
        
    }); 
  }
//----------------------------------------------------------------------


}
